var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInvoiceMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.667 5v2.017c0 1.316.833 2.15 2.15 2.15h2.85V3.342c0-.925-.758-1.684-1.683-1.675a3.35 3.35 0 0 0-2.342.975A3.354 3.354 0 0 0 1.667 5z",
    fill: "url(#p3xp09g2na)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.334 5.833V17.5a.83.83 0 0 1-1.333.666L15.576 17.1a.84.84 0 0 0-1.1.083l-1.384 1.392a.84.84 0 0 1-1.183 0l-1.4-1.4a.826.826 0 0 0-1.083-.075L8 18.166a.835.835 0 0 1-1.334-.666V3.333c0-.917-.75-1.667-1.666-1.667h10c2.5 0 3.333 1.492 3.333 3.334v.833z",
    fill: "url(#4kkriv5xub)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.001 10.216h2.5a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625h-2.5a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625z",
    fill: "url(#aoyc2kefmc)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.501 8.133h-2.5a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h2.5a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625z",
    fill: "url(#8olqel3g8d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.026 6.675a.83.83 0 0 1 .833.833.836.836 0 0 1-.833.833.836.836 0 0 1-.833-.833c0-.458.375-.833.833-.833z",
    fill: "url(#0hqclwn6ye)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.026 10.008a.83.83 0 0 1 .833.833.836.836 0 0 1-.833.834.836.836 0 0 1-.833-.834c0-.458.375-.833.833-.833z",
    fill: "url(#x030tlhu7f)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p3xp09g2na",
    x1: 6.667,
    y1: 1.667,
    x2: 6.667,
    y2: 9.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4kkriv5xub",
    x1: 18.334,
    y1: 1.667,
    x2: 18.334,
    y2: 18.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aoyc2kefmc",
    x1: 13.126,
    y1: 10.216,
    x2: 13.126,
    y2: 11.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8olqel3g8d",
    x1: 13.126,
    y1: 6.883,
    x2: 13.126,
    y2: 8.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0hqclwn6ye",
    x1: 15.859,
    y1: 6.675,
    x2: 15.859,
    y2: 8.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x030tlhu7f",
    x1: 15.859,
    y1: 10.008,
    x2: 15.859,
    y2: 11.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInvoiceMenu);
export default __webpack_public_path__ + "static/media/ic-invoice-menu.3d697981.svg";
export { ForwardRef as ReactComponent };